import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextWidget = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_225_111)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_225_111",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 9,
			width: 32,
			height: 14,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M31.9161 9.1366H0.389648V22.955H31.9161V9.1366Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_225_111)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4.41369 20.4039V10.1065H0.389648V9.1366H9.57128V10.1065H5.54724V20.4039H4.39953H4.41369Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3433 18.0255C16.0741 19.4605 14.6005 20.4969 12.6593 20.4969C10.1797 20.4969 8.59277 18.8626 8.59277 16.2185C8.59277 13.5744 10.1797 11.9003 12.5885 11.9003C14.9972 11.9003 16.4566 13.4947 16.4566 15.9926V16.4444H9.7263V16.4975C9.7263 18.3976 10.8881 19.5668 12.6735 19.5668C14.0195 19.5668 14.983 18.9291 15.2523 17.999H16.3433V18.0255ZM9.74041 15.6206H15.3231C15.3089 13.9465 14.2038 12.8304 12.5885 12.8304C10.9731 12.8304 9.85379 13.9597 9.75459 15.6206H9.74041Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.8076 16.9359L18.328 20.4038H17.0811L20.2408 16.1785L17.1094 12.0065H18.3563L20.8501 15.3946H20.8784L23.3439 12.0065H24.5907L21.4594 16.1387L24.5765 20.4038H23.3297L20.8643 16.9359H20.8359H20.8076Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.3541 9.97351V11.9931H29.1252V12.8568H27.3541V18.2912C27.3541 19.1681 27.7224 19.5401 28.5584 19.5401C28.6718 19.5401 29.111 19.5136 29.1677 19.5136V20.3904C29.0544 20.4171 28.5726 20.4436 28.3317 20.4436C26.844 20.4436 26.2488 19.8457 26.2488 18.331V12.8568H24.9736V11.9931H26.2488V9.97351H27.3541Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.9824 22.955V9.1366H31.9176V22.955H30.9824Z",
					fill: "currentColor"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_225_111",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgTextWidget;
